export const overrides = theme => ({})

export const props = {
  enterDelay: 200,
}
